var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-search animated fadeIn roundedCard" },
    [
      _c(
        "b-card",
        [
          _c("h1", { staticClass: "lbv-page-title" }, [
            _vm._v("\n      Roles API\n    "),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "lbv-search-filter",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "leaklistFilters container" },
                [
                  _c(
                    "b-row",
                    { staticClass: "divider" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("label", [_vm._v("Role:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: { id: "statusFilter" },
                                      nativeOn: {
                                        change: function ($event) {
                                          return _vm.onChange.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.roleSelection,
                                        callback: function ($$v) {
                                          _vm.roleSelection = $$v
                                        },
                                        expression: "roleSelection",
                                      },
                                    },
                                    _vm._l(_vm.userRoles, function (role) {
                                      return _c(
                                        "option",
                                        _vm._b(
                                          {
                                            key: role.id,
                                            domProps: { value: role.id },
                                          },
                                          "option",
                                          _vm.$attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(role.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary applyFilter",
                                    attrs: { id: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push("addApi2Role")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Manage Roles\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary applyFilter",
                                    attrs: { id: "applyBtn", type: "submit" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showUsers()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Show Users\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.modalCreateRole",
                                        modifiers: { modalCreateRole: true },
                                      },
                                    ],
                                    staticClass: "btn btn-primary applyFilter",
                                    attrs: {
                                      variant: "primary",
                                      type: "submit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.showModal = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Create Role\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("label", [_vm._v("API:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: { id: "statusFilter2" },
                                      nativeOn: {
                                        change: function ($event) {
                                          return _vm.onChange2.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.apiSelection,
                                        callback: function ($$v) {
                                          _vm.apiSelection = $$v
                                        },
                                        expression: "apiSelection",
                                      },
                                    },
                                    _vm._l(_vm.APIs, function (api) {
                                      return _c(
                                        "option",
                                        _vm._b(
                                          {
                                            key: api.apiID,
                                            domProps: { value: api.apiID },
                                          },
                                          "option",
                                          _vm.$attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(api.apiName) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary applyFilter",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push("addRole2Api")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Manage APIs\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "newCreateRole",
              attrs: {
                id: "modalCreateRole",
                title: "Create New Role",
                "ok-variant": "primary",
                "ok-title": "Create",
              },
              on: { ok: _vm.createRole, show: _vm.clearInput },
            },
            [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        label: "New Role Name:",
                        "label-cols": 6,
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-md-10 full-width",
                        attrs: { type: "text", required: "" },
                        model: {
                          value: _vm.newRoleName,
                          callback: function ($$v) {
                            _vm.newRoleName = $$v
                          },
                          expression: "newRoleName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        label: "New Role Description:",
                        "label-cols": 6,
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-md-10 full-width",
                        attrs: { type: "text", required: "" },
                        model: {
                          value: _vm.newRoleDescription,
                          callback: function ($$v) {
                            _vm.newRoleDescription = $$v
                          },
                          expression: "newRoleDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }